module.exports = __webpack_public_path__ + "static/media/Wael Fattouh.090b487c.jpg";